import isMobile, { isMobileVR } from "./is-mobile";

// Mediapipe segmentation is too slow on mobile Firefox and freezes after the first frame on mobile Chromium.
// The camera avatar itself still works there, it just shows the raw camera feed.
export const supportsBackgroundRemoval = !isMobile() && !isMobileVR();
